import { Pipe } from '@angular/core';
import { LabelOrAlternativePipe } from './label-or-alternative.pipe';
import { PlacementTypeChoices } from '../../../../model/product/board/board-part';

@Pipe({
  name: 'placementTypeOrAlternative'
})
export class PlacementTypeOrAlternativePipe extends LabelOrAlternativePipe {
  constructor() {
    super(PlacementTypeChoices.OTHER.ordinal);
  }
}
